import Button from '@components/Button';
import PaginateSelect from '@components/PaginateSelect';
import Select from '@components/Select';
import SelectSearch from 'react-select'
import { components } from "react-select";
import TextField from '@components/TextField';
import RadioButton from '@components/RadioButton';
import { apiClient } from '@services/api';
import { useEffect, useState } from 'react';
import { darkSelectStyles } from '@utils/darkSelectStyles';

const Form = (props) => {
  const [cuposOptions, setCuposOptions] = useState([])
  const [openMenuDriver, setOpenMenuDriver] = useState(false)
  const [openMenuGuide, setOpenMenuGuide] = useState(false)
  const [drivers, setDrivers] = useState([]);
  const [driver, setDriver] = useState('');
  const [guides, setGuides] = useState([]);
  const [guide, setGuide] = useState('');

  const radioButtonData = [
    {
      value: 'fixed',
      label: 'Fixo'
    },
    {
      value: 'interval',
      label: 'Intervalo'
    }
  ];

  const getCupos = () => {
    apiClient
      .httpInstance.get('/vehicles')
      .then(response => {
        if (response.status === 200) {
          setCuposOptions(response.data.data);
        }
      });
  }

  const getDrivers = () => {
    apiClient.httpInstance.get(`/drivers?status=true&pageSize=1000`).then(response => {
      if (response.status === 200) {
        let options = []
        response.data.data.map((element) => {
          options.push({ value: element.id, name: element.name, label: element.name })
          if (props.vehicle?.driver_id === element.id) {
            setDriver({ value: element.id, name: element.name, label: element.name.toUpperCase() })
          }
        })
        setDrivers(options)
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  const getGuides = () => {
    apiClient.httpInstance.get(`/guides?status=true&pageSize=1000`).then(response => {
      if (response.status === 200) {
        let options = []
        response.data.data.map((element) => {
          options.push({ value: element.id, name: element.name, label: element.name })
          if (props.vehicle?.guide_id === element.id) {
            setGuide({ value: element.id, name: element.name, label: element.name.toUpperCase() })
          }
        })
        setGuides(options)
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  const handleSelect = (ev, type) => {
    ev.label = ev.label.toUpperCase()
    if (type === 'driver') {
      setDriver(ev)
      props.changeState({ target: { name: 'driver_id', value: ev.value } })
    }
    if (type === 'guide') {
      setGuide(ev)
      props.changeState({ target: { name: 'guide_id', value: ev.value } })
    }
    return ev.value
  }

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  useEffect(() => {
    getCupos()
    getDrivers()
    getGuides()
  }, [])

  return <>
    <form onSubmit={props.submit}>
      <div className="p-4 mt-4 bg-white rounded-xl border-1">
        <div className="flex flex-col md:flex-row flex-wrap gap-4 mb-4">
          <div>
            <TextField
              className="inputRounded"
              label="Apelido"
              variant="outlined"
              type="text"
              name="nickname"
              value={props.vehicle.nickname}
              onChange={(ev) => props.changeState(ev)}
              required
            />
          </div>
          <div style={{ position: "relative", paddingTop: "18px" }}>
            <span style={AboveLabelStyle}>Motorista</span>
            <div style={SearchStyle1}>
              <span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', paddingLeft: '10px', color: openMenuDriver ? 'transparent' : (driver ? '#e8f0fb' : '#8ba5c4'), zIndex: 2, pointerEvents: 'none', borderRadius: '20px', fontSize: '14px' }}>{driver ? driver.label : 'Motorista'}</span>
              <span style={SpanSelect}><SelectSearch
                styles={customStyles}
                placeholder="Motorista"
                menuIsOpen={openMenuDriver}
                onMenuOpen={() => setOpenMenuDriver(true)}
                onMenuClose={() => setOpenMenuDriver(false)}
                options={drivers.map(driver => ({
                  value: driver?.value,
                  name: driver?.name?.toLowerCase(),
                  label: driver?.name?.toLowerCase(),
                }))}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                components={{
                  Option,
                }}
                allowSelectAll={false}
                showSelectedItems={true}
                width='280px'
                value={driver}
                onChange={(ev) => handleSelect(ev, 'driver')}
                name="driver_id"
              /></span>
            </div>
          </div>
          <div style={{ position: "relative", paddingTop: "18px" }}>
            <span style={AboveLabelStyle}>Guia</span>
            <div style={SearchStyle2}>
              <span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', paddingLeft: '10px', color: openMenuGuide ? 'transparent' : (guide ? '#e8f0fb' : '#8ba5c4'), zIndex: 2, pointerEvents: 'none', borderRadius: '20px', fontSize: '14px' }}>{guide ? guide.label : 'Guia'}</span>
              <span style={SpanSelect}><SelectSearch
                styles={customStyles}
                placeholder="Guia"
                menuIsOpen={openMenuGuide}
                onMenuOpen={() => setOpenMenuGuide(true)}
                onMenuClose={() => setOpenMenuGuide(false)}
                options={guides.map(guide => ({
                  value: guide?.value,
                  name: guide?.name?.toLowerCase(),
                  label: guide?.name?.toLowerCase(),
                }))}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                components={{
                  Option,
                }}
                allowSelectAll={false}
                showSelectedItems={true}
                width='280px'
                value={guide}
                onChange={(ev) => handleSelect(ev, 'guide')}
                name="guide_id"
              /></span>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row flex-wrap gap-4 mb-4">
          <div>
            <Select
              withoutAll
              label="Vagas"
              width="100px"
              value={props.idVehicle}
              onChange={(ev) => props.changeIdVehicle(ev.target.value)}
              required
              items={{
                field: {
                  value: 'id',
                  text: 'seats'
                },
                data: cuposOptions
              }}
            />
          </div>
          <div>
            <TextField
              className="inputRounded"
              label="Placa"
              variant="outlined"
              type="text"
              name="license_plate"
              value={props.vehicle.license_plate}
              onChange={(ev) => props.changeState(ev)}
            />
          </div>
        </div>

        <div className="flex-1 space-y-1">
          <RadioButton
            {...props}
            data={radioButtonData}
            name="type_time"
            change={(ev) => props.changeState(ev)}
            value={props.vehicle.type_time}
            required
          />
          <span
            style={{ fontSize: '10px' }}
            id="labelRadioTransfer">Selecione o tipo de horário*
          </span>
        </div>

      </div>
      <div className="text-right">
        <Button
          textcolor="#FFF"
          padding="6px 15px"
          width="200"
          customcolor={props.theme.color}
          type="submit"
        >
          Salvar
        </Button>
      </div>
    </form>
  </>
}

export default Form

const customStyles = {
  ...darkSelectStyles,
  control: (provided, state) => ({
    ...darkSelectStyles.control(provided, state),
    width: '100%',
    opacity: 0,
    height: '36px',
    minHeight: '36px',
    cursor: 'pointer',
  }),
  menu: (provided, state) => ({
    ...darkSelectStyles.menu(provided, state),
    minWidth: '220px',
    width: 'max-content',
    zIndex: 99999,
  }),
  multiValue: () => ({ display: 'none' }),
  multiValueLabel: () => ({ display: 'none' }),
  multiValueRemove: () => ({ display: 'none' }),
}

const SearchStyle1 = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minWidth: '220px',
  minHeight: '56px',
  justifyContent: 'space-between',
  borderRadius: '20px',
  border: '1px solid #2a4f72',
  backgroundColor: '#1e3a5a',
  padding: '4px 10px',
  position: 'relative',
  zIndex: '10006',
  boxSizing: 'border-box',
}

const SearchStyle2 = {
  ...SearchStyle1,
  zIndex: '10004',
}

const AboveLabelStyle = {
  position: 'absolute',
  top: '2px',
  left: '12px',
  fontSize: '11px',
  color: '#8ba5c4',
  fontWeight: '500',
  zIndex: 10,
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
}

const SpanSelect = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
}